import { render, staticRenderFns } from "./BelongsToManyCheckbox.vue?vue&type=template&id=b2af49e4&"
import script from "./BelongsToManyCheckbox.vue?vue&type=script&lang=js&"
export * from "./BelongsToManyCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports